import {
  ExportationActionTypes,
  IGetFollowedExportationsSuccessPayload,
  IAddFollowedExportationPayload,
  IRemoveFollowedExportationPayload,
  ISetExportationSettingsPayload,
  IChangeExportationSettingsPayload,
} from './types'

export const getFollowedExportations = () => {
  return {
    type: ExportationActionTypes.GET_FOLLOWED_EXPORTATIONS
  }
}

export const getFollowedExportationsSuccess = (payload: IGetFollowedExportationsSuccessPayload) => {
  return {
    type: ExportationActionTypes.GET_FOLLOWED_EXPORTATIONS_SUCCESS,
    payload
  }
}

export const addFollowedExportation = (payload: IAddFollowedExportationPayload) => {
  return {
    type: ExportationActionTypes.ADD_FOLLOWED_EXPORTATION,
    payload
  }
}

export const removeFollowedExportation = (payload: IRemoveFollowedExportationPayload) => {
  return {
    type: ExportationActionTypes.REMOVE_FOLLOWED_EXPORTATION,
    payload
  }
}

export const setExportationSettings = (payload: ISetExportationSettingsPayload) => {
  return {
    type: ExportationActionTypes.SET_EXPORTATION_SETTINGS,
    payload
  }
}

export const changeExportationSettings = (payload: IChangeExportationSettingsPayload) => {
  return {
    type: ExportationActionTypes.CHANGE_EXPORTATION_SETTINGS,
    payload
  }
}
